<template>
  <LoadingAspn type="squad" v-show="isLoading" />
  <div v-show="!isLoading">
    <div v-show="teamInfo.squadData">
      <!-- <div class="nav-pill__wrapper mb-main container" > -->
      <!-- <div class="nav-pill selected" >Season 2020-2011</div> -->
      <!-- </div> -->
      <!-- <div class="team-info__overview-card" v-for="(o, index) in overviewList" :key="index">
                      <div class="team-info__overview-header">{{o.title}}</div>
                      <div class="team-info__overview-body"  v-for="(level2, index) in o.child" :key="index">
                          <div class="">{{level2.key}}</div>
                          <div class="">{{level2.value}}</div>
                      </div>
                  </div> -->
      <div class="squad-container">
        <div class="squad-list" v-for="(item, key) in squadList" :key="key">
          <div class="squad-title">
            {{ key }}
          </div>
          <div class="squad-item">
            <Navigation
              :id="level2.id"
              :category="'player'"
              :name="level2.name"
              class="squad-player-list"
              v-for="(level2, index) in item"
              :key="index"
            >
              <div class="squad-player">
                <div class="player-no">
                  {{ level2.number === "" ? "#" : level2.number }}
                </div>
                <Icon
                  :category="'player'"
                  :logoUrl="level2.logo"
                  class="team-info__overview-goal__player-img"
                ></Icon>
                <div class="player-item">
                  <div class="player-country">
                    <!-- <img
                      src="https://asset.ASPN.com/football/gs/team/36/27.png"
                    /> -->
                    {{ level2.countryName }}
                  </div>
                  <div class="player-name">{{ level2.name }}</div>
                </div>
              </div>
            </Navigation>
          </div>
        </div>
      </div>
  
      <!-- <div class="team-info__overview-card">
                      <div class="team-info__overview-body__header">
                          <div class="team-info__overview-goal__player">
                              <div class="team-info__overview-goal__player-rank">#</div>
                              <div>{{$t('PLAYER')}}</div>                          
                          </div>
                          <div class="display-flex team-info__overview-goal__player-goal__title">
                              <div class="team-info__overview-goal__player-goal">{{$t('POSITION')}}</div>
                          </div>
                      </div>
                      <Navigation :id="level2.id" :category="'player'" :name="level2.name"  class="team-info__overview-body"   v-for="(level2, index) in teamInfo.squadData" :key="index">
                          <div class="team-info__overview-goal__player">
                              <div class="team-info__overview-goal__player-rank" v-if="level2.number===''">#</div>
                               <div class="team-info__overview-goal__player-rank" v-else>{{level2.number}}</div>
                               <Icon :category="'player'" :logoUrl=level2.logo  class="team-info__overview-goal__player-img"></Icon>
                              <div class="team-info__overview-goal__player-name">{{level2.name}}</div>
                          </div>
                          <div class="display-flex team-info__overview-goal__player-goal__title">
                              <div class="team-info__overview-goal__player-goal">{{$t(level2.pos)}}</div>                        
                          </div>                      
                      </Navigation>
                  </div> -->
    </div>
    <div v-show="!teamInfo.squadData" class="pa-05rem">
      <NoData text="NO_SQUAD" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    isLoading: Boolean,
  },
  computed: {
    ...mapGetters([
      "teamInfo",
      "isMobile",
      "currentLocale",
      "currentSportType",
    ]),
    squadList() {
      let obj = {};
      let list = this.teamInfo.squadData;
      for (var index in list) {
        let pos = list[index].pos;
        if (!obj[pos]) {
          obj[pos] = [];
        }
        obj[pos].push(list[index]);
      }
      return obj;
    },
  },
};
</script>

<style scoped>
.team-info__overview-goal__player-goal__title {
  flex: 0.5;
}
.team-info__overview-goal__player-goal {
  flex: 1;
  text-align: center;
}
.squad-container {
  border-radius: 16px;
  background: var(--color-background-default-secondary);
  padding: 24px;
}
.squad-list {
  border-bottom: 1px solid var(--color-border-default-default);
  padding: 0 0 40px;
  margin-bottom: 40px;
}
.player-no {
  flex-shrink: 0;
  width: 45px;
  text-align: center;
  font-weight: var(--typography-button-font-weight);
  font-family: var(--typography-button-font-family);
  font-size: var(--typography-button-size-small);
}
.squad-title {
  font-family: var(--typography-heading-font-family);
  font-size: var(--typography-heading-size-extra-small);
  padding-bottom: 28px;
  font-family: var(--weight-700);
  color: var(--color-text-default-default);
}
.squad-player {
  align-items: center;
  display: flex;
  gap: 15.2px;
}
.player-country {
  display: flex;
  align-items: center;
  font-family: var(--typography-caption-font-family);
  font-size: var(--typography-caption-size-large);
  font-weight: var(--typography-caption-font-weight-regular);
  color: var(--color-text-default-secondary);
	letter-spacing: 0.2px;
}
.player-country img {
  height: 22px;
  margin-right: 8px;
  border-radius: 50%;
  border: 1px solid lightgrey;
}
.player-name {
  font-size: var(--typography-body-size-large);
  font-family: var(--weight-600);
  letter-spacing: 0.64px;
}
.squad-item {
  display: grid;
  grid-template-columns: repeat(3, 33.33%);
  row-gap: 40px;
}

@media(max-width: 768px) { /* for test */
  .squad-container {
    border-radius: 8px;
    padding: 16px 0;
    margin: 16px 8px;
  }
  .squad-item {
    display: block;
  }
  .squad-player {
    margin-bottom: 24px;
    gap: 12px;
  }
  .squad-title {
    padding: 0 16px 40px;
    font-size: 20px;
  }
  .player-country {
    margin-bottom: 4px;
    font-size: 13px;
  }
  .squad-player-list {
    padding: 0 0;
  }
  .squad-list {
    padding: 0 0 28px;
    /* margin-bottom: 28px; */
    margin: 0 16px 28px;
  }
}
</style>
